module.exports = __webpack_public_path__ + "static/media/printer@2x.94a03e5b.png";